/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, Input, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { Tab } from './../../../core/model/tab.model';
import { environment } from './../../../../environments/environment';

/**
 * @export
 * @class LmsHeaderSubTypesComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-header-sub-types',
  templateUrl: './lms-header-sub-types.component.html',
  styleUrls: ['./lms-header-sub-types.component.scss']
})
export class LmsHeaderSubTypesComponent implements OnInit {
  @Input() tab: Tab;
  @Input() subTypes: Array<string>;
  @Input() tabIndex: number;
  hideUrl = environment.hideUrl;
  constructor(private router: Router) { }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LmsHeaderSubTypesComponent
   */
  ngOnInit() {
  }
}
